import React from 'react';
import { Typography, Box, Card, CardContent } from '@mui/material';
import './RecentCard.css';
import { Link } from 'react-router-dom';
import DocsPreviewImage from '../../Docs/DocsPreviewImage';

const RecentCard = (props) => (
    <Card className="recent-card">
        <CardContent className="recent-content">
            <DocsPreviewImage postId={props.id} className="recent-image" alt={`${props.title} preview`} />
            <Box className="recent-text">
                <Typography variant="body1" className="recent-title">{props.title}</Typography>
                <Typography variant="body1" className="read-more">
                    <Link to={`/docs/post/${props.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        Read More
                    </Link>
                </Typography>
            </Box>
        </CardContent>
    </Card>
);

export default RecentCard;
